import React from "react";

export function PageHeader({ eyebrow, title, description, children }) {
  return (
    <div className="border-b border-[#e5e5e5] bg-white px-10 py-10 flex items-end justify-between gap-8">
      <div>
        <div className="label-overline">{eyebrow}</div>
        <h1 className="mt-3 font-display font-bold tracking-tighter text-3xl text-[#111]" data-testid="page-title">
          {title}
        </h1>
        {description && <p className="mt-2 text-sm text-[#52525b] max-w-xl">{description}</p>}
      </div>
      <div className="flex items-center gap-3">{children}</div>
    </div>
  );
}
